const STORE_KEY = 'APPS'

export const FETCH_APPS = `${STORE_KEY}/FETCH_APPS`
